import { hasProperty } from '../util';
export function isUnitSpec(spec) {
    return hasProperty(spec, 'mark');
}
//# sourceMappingURL=unit.js.map